import i18n from "config/i18next";

i18n.addResources("es", "detailTransaction", {
  transactionCode: "Código de transacción",
  orderNumber: "Nro de orden",
  date: "Fecha y hora",
  pickerId: "Id del picker",
  finalConsumer: "Consumidor final",
  pickerFullName: "Nombre y apellido",
  selectCacelationReason: " Seleccioná el motivo de cancelación de la colecta",
  cancelTransaction: " Estás por cancelar la transacción",
  confirmCancelTransaction: " Al hacerlo, ya no va a poder ser asignada",
  confirmCancelTransactionQuestion: "¿Querés cancelarla?",
  confirmCancelTransactionQConfimr: "Sí, cancelarla",
  cancelCollection: "Estás por cancelar la colecta",
  reason: "Motivo",
  tripCode: "Código de viaje",
  selectFinalState: "Seleccioná el estado final que quieras asignarle",
  infoTransaction: "La transacción ",
  infoFinalState: " va a pasar a estado:",
  finish: "Finalizar",
  dniReceiver: "Ingresá los datos de quién recibió el paquete",
  dniPlaceholder: "Ingresá el número de identificación",
  dniLabel: "Número de identificación *",
  namePlaceholder: "Ingresá el nombre",
  nameLabel: "Nombre *",
  lastNamePlaceholder: "Ingresá el apellido",
  lastNameLabel: "Apellido *",
  relationshipPlaceholder: "Seleccioná quién recibió",
  relationshipLabel: "¿Quién recibió el paquete? *",
  serialNumberLabelRequired: "Número serial *",
  serialNumbersLabelRequired: "Números seriales *",
  serialNumberLabel: "Número serial",
  serialNumbersLabel: "Números seriales",
  serialNumberPlaceholder: "Seleccioná el número serial",
  serialNumbersPlaceholder: "Seleccioná los números seriales",
  serialNumberCodeMismatch: "El número de serie debe coincidir con el código recibido.",
  serialNumberSelectAll: "Debés seleccionar todos los seriales asociados.",
  serialNumberHelperTextSingular: "La transacción tiene {{count}} serial asociado.",
  serialNumberHelperTextPlural: "La transacción tiene {{count}} seriales asociados.",
  deliveryAddress: "Dirección de entrega",
  pickupAddress: "Dirección de retiro",
  retailer: "Retailer",
  sku: "SKU",
  region: "Región",
  seePicker: "Ver picker",
  history: "Historial",
  cancelWarning:
    "Al desasignar la transacción, va a volver al estado sin asignar",
  cancelConfirmation: "¿Querés cancelar la colecta?",
  undeliveredReason: "Seleccioná el motivo de imposible de entrega",
  dniInvalidError: "El DNI es inválido",
  idLongError: "El ID debe tener entre 6 y 15 caracteres",
  dniLongError: "El DNI debe tener entre 7 y 8 caracteres numéricos",
  areaCode: "Código de área ",
  phone: "Teléfono ",
  lost: "Siniestrado",
  delivered: "Entregado",
  returned: "Devuelto",
  invalidFormat: "El formato ingresado es inválido",
  tripCodeLabel: "Código de viaje",
  tripCodePlaceHolder: "-",
  seePhoto: "Ver foto",
  seeSign: "Ver firma",
  seeDeliveryEvidence: "Ver evidencias de entrega",
  deliveryCoordinates: "Las coordenadas de entrega fueron {{coordinates}}.",
  finishByAdmin: "Motivo: entregado por admin",
  long: "Longitud:",
  lat: "Latitud:",
  confidetialMenssage:
    "Esta imagen es de carácter confidencial y no deberá compartirse a personas externas.",
  confidential: "CONFIDENCIAL",
  clientsLabel: "¿Quién recibe el paquete? *",
  clientsPlaceholder: "Seleccioná",
  uploadFile: "Subir foto",
  uploadSign: "Subir firma",
  delete: "Eliminar",
  tooltipFile: "Subí un archivo JPG o PNG de hasta 5 MB.",
  deliveryProofErrorTitle: "Solicitud sin finalizar",
  deliveryProofErrorBody:
    "Se modificó el estado de esta transacción previamente",
  openInGoogleMaps: "Coordenadas de entrega",
  receiverNameAndLastName: "Nombre y apellido: ",
  receiverName: "Nombre: ",
  receiverLastName: "Apellido: ",
  receiverRelationship: "Parentesco: ",
});

i18n.addResources("es_AR", "detailTransaction", {
  dniPlaceholder: "Ingresá el número de DNI",
  dniLabel: "DNI *",
  receiverDni: "DNI: ",
});

i18n.addResources("es_MX", "detailTransaction", {
  dniPlaceholder: "Ingresá el CURP",
  dniLabel: "CURP *",
  receiverDni: "CURP: ",
  tooltipFile: "Sube un archivo JPG o PNG de hasta 5 MB.",
});

i18n.addResources("es_CL", "detailTransaction", {
  dniPlaceholder: "Ingresá el RUN",
  dniLabel: "RUN *",
  receiverDni: "RUN: ",
  tooltipFile: "Sube un archivo JPG o PNG de hasta 5 MB.",
});

i18n.addResources("es_CO", "detailTransaction", {
  dniPlaceholder: "Ingresá el número de identificación",
  dniLabel: "Número de identificación *",
  receiverDni: "Número de identificación: ",
  tooltipFile: "Sube un archivo JPG o PNG de hasta 5 MB.",
});